import JobApply from ".";

export const jobApplyRoutes = () => [
  {
    path: "/user/job-apply",
    component: JobApply,
    layout: "user",
    routeType: "user",
    title: "User Jobs Management",
  },
];